import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import Box from 'ui-box';
import { Typography, Rate, Row, Col } from 'antd';

const { Title } = Typography;

const styles = {
  question: {
    fontWeight: "600", 
    fontSize: "24px", 
    lineHeight: "30px", 
    textAlign: "center", 
    color: "#404047",
    marginBottom: 25,
    marginTop: 50
  }
}

const MobileInputRate = ({fieldName, question}) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      {
        question && (
          <Title level={4} style={styles.question}>
            {t(`${question}`)}
          </Title>
        )
      }
      <Box width="100%">
        <Row justifyContent="center">
          <Col xs={24}>
            <Rate
              onChange={(e) => setFieldValue(fieldName, e)}
              value={values.rating}
              style={{ fontSize: 36, textAlign: 'center', width: '100%' }}
            />
          </Col>
        </Row>
      </Box>
    </>
  );
}

export default MobileInputRate;
